export default __webpack_public_path__ + "static/media/kf6012.ecfafbc1.png";